var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentPartner01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "content partner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.44,22.89l0,0,3.71-3.64L22,13.46a4.06,4.06,0,0,0,.12-5.74L18.08,3.56a4.07,4.07,0,0,0-5.75,0l-.27.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.1 6.76 7.27 8.56 2.9 12.85 2.73 13.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.22,13.4,7.85,17.7a1.9,1.9,0,0,1-2.67.19h0a1.89,1.89,0,0,1,.24-2.66l4.37-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.7,11l-4.38,4.3a1.91,1.91,0,0,1-2.67.2h0a1.91,1.91,0,0,1,.25-2.67l4.37-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.65,15.87l-4.38,4.3a1.9,1.9,0,0,1-2.67.19h0a1.89,1.89,0,0,1,.25-2.66l4.37-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.17,19.23l-3.71,3.64a1.74,1.74,0,0,1-2.45,0h0a1.73,1.73,0,0,1,0-2.45l3.7-3.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.06,3.85l2.92,3a2.07,2.07,0,0,1-1.49,3.53A2,2,0,0,1,12,9.72l-2.91-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.71,12.08a3.44,3.44,0,0,1,0-4.89L5.9,3.11a3.87,3.87,0,0,1,5.48.05l.68.69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPartner01);
export default __webpack_public_path__ + "static/media/content_partner_01.be48e34920bb1e950022d73cc4c7b124.svg";
export { ForwardRef as ReactComponent };